/**
 * Analytics & Statistics API endpoints
 */
import { api } from './baseApi';
import type {
  DashboardOverviewResponse,
  UserStatsResponse,
  ServicesStatsResponse,
  SpecialistsStatsResponse,
  OrdersStatsResponse,
  RevenueStatsResponse,
} from '../../types/dashboard';

export const analyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getKPIs: builder.query<DashboardOverviewResponse, void>({
      query: () => '/dashboard/overview/',
      providesTags: ['Statistics'],
    }),
    getUserStatistics: builder.query<UserStatsResponse, void>({
      query: () => '/dashboard/stats/users/',
      providesTags: ['Statistics'],
    }),
    getServicesStatistics: builder.query<ServicesStatsResponse, void>({
      query: () => '/dashboard/stats/services/',
      providesTags: ['Statistics'],
    }),
    getSpecialistsStatistics: builder.query<SpecialistsStatsResponse, void>({
      query: () => '/dashboard/stats/specialists/',
      providesTags: ['Statistics'],
    }),
    getOrdersStatistics: builder.query<OrdersStatsResponse, void>({
      query: () => '/dashboard/stats/orders/',
      providesTags: ['Statistics'],
    }),
    getRevenueStatistics: builder.query<RevenueStatsResponse, void>({
      query: () => '/dashboard/stats/revenue/',
      providesTags: ['Statistics'],
    }),
  }),
});

export const {
  useGetKPIsQuery,
  useGetUserStatisticsQuery,
  useGetServicesStatisticsQuery,
  useGetSpecialistsStatisticsQuery,
  useGetOrdersStatisticsQuery,
  useGetRevenueStatisticsQuery,
} = analyticsApi;

